import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Loader2, KeyRound } from "lucide-react";
import { api } from "@/lib/api";
import { RESTABLECER } from "@/constants/testIds";
import { usePageTitle } from "@/lib/usePageTitle";

export default function RestablecerContrasena() {
  usePageTitle("Restablecer contraseña");
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [nueva, setNueva] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [error, setError] = useState("");
  const [exito, setExito] = useState(false);
  const [cargando, setCargando] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (nueva.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres");
      return;
    }
    if (nueva !== confirmar) {
      setError("Las contraseñas no coinciden");
      return;
    }
    setCargando(true);
    try {
      await api.post("/auth/reset-password", { token, password_nueva: nueva });
      setExito(true);
    } catch (err) {
      setError(err?.response?.data?.detail || "El enlace no es válido o ya venció.");
    } finally {
      setCargando(false);
    }
  };

  if (!token) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[var(--tc-surface)] px-5">
        <p data-testid={RESTABLECER.error} className="max-w-sm rounded-[var(--tc-radius)] bg-red-50 px-4 py-3 text-center text-sm text-red-600">
          Este enlace no es válido. Solicitá uno nuevo desde{" "}
          <Link to="/recuperar-contrasena" className="underline">acá</Link>.
        </p>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--tc-surface)] px-5">
      <div className="w-full max-w-sm rounded-[var(--tc-radius)] border border-[var(--tc-border)] bg-white p-8 tc-fade-up">
        <div className="mb-6 flex flex-col items-center text-center">
          <span className="flex h-11 w-11 items-center justify-center rounded-[var(--tc-radius)] bg-[var(--tc-accent)] text-white">
            <KeyRound size={20} strokeWidth={2.2} />
          </span>
          <h1 className="mt-3 text-lg font-semibold text-[var(--tc-text)]">Elegí una nueva contraseña</h1>
        </div>

        {exito ? (
          <div className="flex flex-col gap-4">
            <p data-testid={RESTABLECER.success} className="rounded-[var(--tc-radius)] bg-green-50 px-3 py-3 text-sm text-green-700">
              Contraseña actualizada. Ya podés iniciar sesión.
            </p>
            <div className="flex justify-center gap-4 text-sm">
              <Link to="/admin/login" className="text-[var(--tc-accent)] hover:underline">Panel interno</Link>
              <Link to="/portal/login" className="text-[var(--tc-accent)] hover:underline">Portal cliente</Link>
            </div>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="flex flex-col gap-4">
            <div>
              <label className="mb-1.5 block text-sm font-medium text-[var(--tc-text)]">Nueva contraseña</label>
              <input
                data-testid={RESTABLECER.passwordInput}
                type="password"
                required
                value={nueva}
                onChange={(e) => setNueva(e.target.value)}
                className="w-full rounded-[var(--tc-radius)] border border-[var(--tc-border)] px-3.5 py-2.5 text-sm outline-none focus:border-[var(--tc-accent)] focus:ring-2 focus:ring-[var(--tc-accent-soft)]"
              />
            </div>
            <div>
              <label className="mb-1.5 block text-sm font-medium text-[var(--tc-text)]">Confirmar contraseña</label>
              <input
                data-testid={RESTABLECER.confirmInput}
                type="password"
                required
                value={confirmar}
                onChange={(e) => setConfirmar(e.target.value)}
                className="w-full rounded-[var(--tc-radius)] border border-[var(--tc-border)] px-3.5 py-2.5 text-sm outline-none focus:border-[var(--tc-accent)] focus:ring-2 focus:ring-[var(--tc-accent-soft)]"
              />
            </div>
            {error && (
              <p data-testid={RESTABLECER.error} className="rounded-[var(--tc-radius)] bg-red-50 px-3 py-2 text-sm text-red-600">
                {error}
              </p>
            )}
            <button
              data-testid={RESTABLECER.submitButton}
              type="submit"
              disabled={cargando}
              className="mt-1 inline-flex items-center justify-center gap-2 rounded-[var(--tc-radius)] bg-[var(--tc-accent)] px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[var(--tc-accent-hover)] disabled:cursor-not-allowed disabled:opacity-60"
            >
              {cargando ? <Loader2 size={16} className="animate-spin" /> : null} Guardar contraseña
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
